module.exports = __webpack_public_path__ + "f45b0e09ae2304455d995593b14df391.pdf";